function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white px-6 py-12">
      <div className="max-w-3xl mx-auto">

        <h1 className="text-4xl font-extrabold mb-6 text-white">Contact Us</h1>
        <p className="text-lg text-slate-200 mb-8">
          Have questions or need help? We're here to assist you. Reach out to NestQuest for inquiries, partnerships, or support.
        </p>

        <form className="bg-white rounded-lg shadow-lg p-6 text-gray-800 space-y-4">
          <div>
            <label htmlFor="name" className="block font-semibold mb-1">
              Your Name
            </label>
            <input
              type="text"
              id="name"
              placeholder="Enter your full name"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label htmlFor="email" className="block font-semibold mb-1">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label htmlFor="message" className="block font-semibold mb-1">
              Message
            </label>
            <textarea
              id="message"
              rows={5}
              placeholder="How can we help you?"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            ></textarea>
          </div>

          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
          >
            Send Message
          </button>
        </form>

        <div className="mt-10 text-slate-300">
          <h2 className="text-xl font-semibold mb-2">Visit or Reach Us</h2>
          <p>📍 Lusaka, Zambia</p>
          <p>📞 +260 775113623</p>
          <p>✉️ chikondejunior@gmail.com</p>
        </div>

      </div>
    </div>
  );
}

export default Contact;
